import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";
import "./GetMatched.css";

export default function Interest() {
  const formRef = useRef();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    subscription: "",
    contentType: "",
    videosPerMonth: "",
    goals: "",
    budget: "",
    extra: "",
    time: "" // timestamp
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const timestamp = new Date().toLocaleString();
    setFormData((prev) => ({ ...prev, time: timestamp }));

    emailjs
      .sendForm(
        "service_zftzsqj", // SERVICE ID
        "template_c8w7kis", // TEMPLATE ID
        formRef.current,
        "7s78ggShko2iPycBe" // PUBLIC KEY
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Thanks! We'll review your submission and get back to you in 24–48 hours.");

          setFormData({
            name: "",
            email: "",
            company: "",
            subscription: "",
            contentType: "",
            videosPerMonth: "",
            goals: "",
            budget: "",
            extra: "",
            time: ""
          });

          // redirect to Thanks page
          setTimeout(() => {
            navigate("/thanks");
          }, 500);
        },
        (error) => {
          console.log(error.text);
          alert("Something went wrong. Please try again later.");
        }
      );
  };

  return (
    <section className="interest-wrapper">
      <h1>Work with us</h1>
      <p className="intro">
        Tell us about your project below and we’ll get back to you within 24–48 hours. <br />
        Est. time to complete form: 3–5 minutes.
      </p>

      <form ref={formRef} onSubmit={handleSubmit} className="interest-form">
        {/* Name */}
        <label>
          Your Name*
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </label>

        {/* Email */}
        <label>
          Email*
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </label>

        {/* Company */}
        <label>
          Company / Channel (optional)
          <input
            type="text"
            name="company"
            value={formData.company}
            onChange={handleChange}
          />
        </label>

        {/* Project Type */}
        <label>
          Do you need multiple videos per month or a one-time project?*
          <select
            name="subscription"
            value={formData.subscription}
            onChange={handleChange}
            required
          >
            <option value="">Select</option>
            <option value="One-Time">One-Time Project</option>
            <option value="Subscription">Monthly Subscription</option>
          </select>
        </label>

        {/* Content Type */}
        <label>
          What type of content do you need edited?*
          <select
            name="contentType"
            value={formData.contentType}
            onChange={handleChange}
            required
          >
            <option value="">Select</option>
            <option value="YouTube">YouTube videos</option>
            <option value="Reels">TikTok / Instagram Reels</option>
            <option value="Brand">Brand / Commercial Projects</option>
            <option value="Other">Other</option>
          </select>
        </label>

        {/* Videos per Month */}
        {formData.subscription === "Subscription" && (
          <label>
            How many videos per month?*
            <select
              name="videosPerMonth"
              value={formData.videosPerMonth}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="1-2">1–2</option>
              <option value="3-4">3–4</option>
              <option value="5-6">5–6</option>
              <option value="7+">7+</option>
            </select>
          </label>
        )}

        {/* Budget One-Time */}
        {formData.subscription === "One-Time" && (
          <label>
            What’s your budget range for this project?*
            <select
              name="budget"
              value={formData.budget}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="250-500">$250–$500</option>
              <option value="550-800">$550–$800</option>
              <option value="800+">$800+</option>
            </select>
          </label>
        )}

        {/* Budget Subscription */}
        {formData.subscription === "Subscription" && (
          <label>
            What’s your monthly budget range?*
            <select
              name="budget"
              value={formData.budget}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="895">Under $1,000</option>
              <option value="1000-2500">$1,000–$2,500/month</option>
              <option value="2500-4000">$2,500–$4,000/month</option>
              <option value="4000+">$4,000+/month</option>
            </select>
          </label>
        )}

        {/* Goals */}
        <label>
          What’s your main goal with these videos?*
          <textarea
            name="goals"
            value={formData.goals}
            onChange={handleChange}
            required
            placeholder="e.g. Grow my channel, brand awareness, ad conversions"
          />
        </label>

        {/* Extra */}
        <label>
          Anything else we should know? (Optional)
          <textarea
            name="extra"
            value={formData.extra}
            onChange={handleChange}
            placeholder="Style preferences, workflow notes, or special requests"
          />
        </label>

        {/* Submit */}
        <button type="submit" className="btn-submit">
          Submit
        </button>

        <input type="hidden" name="time" value={formData.time} />
      </form>
    </section>
  );
}
